var map = {
	"./19.JPG": 192,
	"./20210501_091914726_iOS.jpg": 193,
	"./22.jpg": 194,
	"./Close-1.JPG": 195,
	"./CloseUp2.jpeg": 196,
	"./IMG-20230508-WA0172.jpg": 197,
	"./IMG-20230508-WA0173.jpg": 198,
	"./IMG-20230508-WA0175.jpg": 199,
	"./IMG-20230508-WA0176.jpg": 200,
	"./IMG-20230508-WA0177.jpg": 201,
	"./IMG-20230508-WA0178.jpg": 202,
	"./Veg.png": 203,
	"./WhatsApp Image 2021-02-23 at 22.46.54.jpeg": 204,
	"./WhatsApp Image 2021-02-23 at 22.49.29 (17).jpeg": 205,
	"./_23.jpg": 206,
	"./event-3.jpg": 207,
	"./event-6.JPG": 208
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 191;